import React from 'react';
import CarRegContainer from '../../containers/carmng/CarRegContainer';

const CarRegPage = () => {
  return (
    <>
      <CarRegContainer />
    </>
  );
};

export default CarRegPage;